import {ValueObject} from '@s-ui/domain'

export class NavigationLinksRequestValueObject extends ValueObject {
  /**
   * @param {Object} deps
   * @param {Number} deps.currentPosition
   * @param {Number} deps.id
   * @param {String} deps.type
   */

  getCurrentPosition = () => this._currentPosition
  getId = () => this._id
  getType = () => this._type
}
